import { getOrgId, graphQLClient } from '@devd-client/api';
import { gql } from 'graphql-request';
import { GoalTableResponse } from '../types';

export const goalsDataGraphql = async (
  goalScope: string,
  author?: string,
  teamId?: string
): Promise<GoalTableResponse> =>
  await graphQLClient.request(
    gql`
      query GetGoalTable($filter: Filter!, $goalScope: String!) {
        GoalTable(filter: $filter, goalScope: $goalScope) {
          id
          title
          description
          scope
          associatedIds
          timeframe
          startDate
          endDate
          status
          progress {
            color
            successRate
            data
          }
          keyResultStatusData {
            totalCount
            atRiskCount
            behindCount
            onTrackCount
          }
          keyResults {
            id
            goalId
            title
            metricName
            metricTitle
            unit
            metricOperator
            targetValue
            currentValue
            weight
            successRate
            status
            color
            data
            activeSince
            updatedBy
          }
        }
      }
    `,
    {
      goalScope,
      filter: {
        orgId: getOrgId(),
        ...(author && { author }),
        ...(teamId && { teamId }),
      },
    }
  );
